import { Injectable } from '@angular/core';

@Injectable()
export class InternalApiService {
  doSomeEditorStuff(id: unknown): any {}
}
